import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import Get_Order from "../Sub_Componet/Get_Order";

let source = axios.CancelToken.source();

class Allocate_extend_trip_report extends Component {
    constructor() {
        super();
        var date = new Date();
        this.state = {
            allovehs: [],
            allovehsl: false,
        }
    }

    async componentDidMount() {
        this.get_allocation_for_extend();
    }

    get_allocation_for_extend = () => {
        let baseurl = myconfig.get_allocation_for_extender_report;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            allovehs: [],
            allovehsl: false,
            cushow2: false,
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            order_id: this.state.order_id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    allovehs: res.data,
                    allovehsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    tabledata2 = () => {
        let count = 0;
        let retdata = null;
        if (this.state.allovehsl) {
            retdata = this.state.allovehs.datas.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.status}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.tra_plateno}</td>
                    <td>{value.dateofloading}</td>
                    <td>{value.dateofdeparture}</td>
                    <td>{value.dateofarivalatoffloadpoint}</td>
                    <td>{value.req_by}</td>
                    <td>{value.req_date}</td>
                    <td>{value.req_remark}</td>
                    <td>{value.app_by}</td>
                    <td>{value.app_date}</td>
                    <td>{value.app_remark}</td>
                    <td>{value.extended_to}</td>
                    <td>{value.extended_km}</td>
                    <td>{value.status}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    render() {
        return (
            <>
                <Nav type="allocate_extend_trip_report"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Trip extender report</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Extender
                                            report</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <input type="text" name="table_search"
                                                       className="form-control float-right" placeholder="Search"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                        <table className="table table-head-fixed text-nowrap">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Truck Plate #</th>
                                                <th>Truck Status</th>
                                                <th>Driver Name</th>
                                                <th>Driver Phone</th>
                                                <th>Trailer #</th>
                                                <th>Date of loading</th>
                                                <th>Date of departure</th>
                                                <th>Date Arival @ unload</th>
                                                <th>Requested By</th>
                                                <th>Requested Date</th>
                                                <th>Requested Remark</th>
                                                <th>Approved By</th>
                                                <th>Approved Date</th>
                                                <th>Approved Remark</th>
                                                <th>Extended To</th>
                                                <th>Extended KM</th>
                                                <th>Status</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.tabledata2()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}
export default Allocate_extend_trip_report;
